/** Nome canale BroadcastChannel tra tab Auth-App (stesso origin). */
export const AMCF_TAB_CHANNEL = 'pn-amcf-auth-tab-coordinator';

/** Chiave `localStorage` di backup (evento `storage` sulle altre tab). */
export const AMCF_TAB_STORAGE_KEY = 'pn-amcf-auth-tab-coordinator';

export const AMCF_TAB_MESSAGE_TAB_CLAIM = 'TAB_CLAIM' as const;
export const AMCF_TAB_MESSAGE_TAB_SUPERSEDED = 'TAB_SUPERSEDED' as const;

export type AmcfTabMessageType = typeof AMCF_TAB_MESSAGE_TAB_CLAIM | typeof AMCF_TAB_MESSAGE_TAB_SUPERSEDED;

/** Numero massimo di peer tracciati in `peerClaims`. */
export const AMCF_TAB_PEER_MAX_COUNT = 20;

/** Rimuove un peer se non invia `TAB_CLAIM` entro questo intervallo. */
export const AMCF_TAB_PEER_STALE_MS = 600_000;

/** Intervallo minimo tra due risposte `TAB_CLAIM` verso lo stesso peer. */
export const AMCF_TAB_CLAIM_REPLY_MIN_MS = 300;
